import { TranslateService } from '@ngx-translate/core';

export function setDefaultLanguageFactory(translateService: TranslateService): () => void {
  return () => {
    translateService.setDefaultLang('en-US');
  };
}
